import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Cotizacion } from '@interfaces/cotizacion.interface';
import { CrearCotizacionModel } from '@models/crear-cotizacion-request/crear-cotizacion.model';
import { SeleccionarPlanModel } from '@models/seleccionar-plan-request/seleccionar-plan.model';
import { AgregarContratanteModel } from '@models/agregar-contratante-request/agregar-contratante.model';
import { SubirFacturaModel } from '@models/subir-factura-request/subir-factura.model';
import { tap } from 'rxjs/operators';
import { downloadBlobFile } from '@utils/file.util';
import { DatosAseguradoPoliza } from '@interfaces/datos-asegurado-poliza.interface';
import { DatosInspeccionResponse } from '@interfaces/datos-inspeccion-response.interface';
import { ServerResponse } from '@interfaces/server-response.interface';
import { AgregarAseguradoAdicionalRequest } from '@models/agregar-asegurado-adicional/agregar-asegurado-adicional-request.interface';

@Injectable({ providedIn: 'root' })
export class CotizacionService {
  constructor(private http: HttpClient) {}

  crearCotizacion(
    crearCotizacionModel: CrearCotizacionModel
  ): Observable<Cotizacion> {
    return this.http.post<Cotizacion>(
      '/cotizacion/directo',
      crearCotizacionModel
    );
  }

  seleccionarPlan(seleccionarPlanModel: SeleccionarPlanModel): Promise<any> {
    return this.http
      .post('/cotizacion/seleccionar-plan', seleccionarPlanModel.request, {
        responseType: 'text',
      })
      .toPromise();
  }

  agregarContratante(
    agregarContratanteModel: AgregarContratanteModel
  ): Observable<Cotizacion> {
    return this.http.post<Cotizacion>(
      '/cotizacion/agregar-contratante',
      agregarContratanteModel
    );
  }

  subirFactura(subirFacturaModel: SubirFacturaModel) {
    const formData = new FormData();
    const { request } = subirFacturaModel;
    formData.append('file', request.file);
    return this.http.post('/cotizacion/subir-factura', formData, {
      params: {
        cotizacionId: request.cotizacionId.toString(),
      },
    });
  }

  obtenerDatosComprobante(
    cotizacionId: string
  ): Observable<DatosAseguradoPoliza> {
    return this.http.get<DatosAseguradoPoliza>(
      '/cotizacion/ObtenerDatosComprobante',
      {
        params: {
          cotizacionId: cotizacionId,
        },
      }
    );
  }

  generarSolicitudInspeccion(
    idCotizacion: string
  ): Observable<ServerResponse<string>> {
    return this.http.post<ServerResponse<string>>(
      '/cotizacion/generar-solicitud-inspeccion',
      {
        idCotizacion,
      }
    );
  }

  descargarComprobante(cotizacionId: number) {
    return this.http
      .get('/cotizacion/descargar-comprobante', {
        responseType: 'blob',
        params: {
          cotizacionId: cotizacionId.toString(),
        },
      })
      .pipe(
        tap((response) => {
          downloadBlobFile(response, 'comprobante.pdf');
        })
      );
  }

  agregarAseguradoAdicional(
    agregarAseguradoAdicionalRequest: AgregarAseguradoAdicionalRequest
  ) {
    return this.http.post(
      '/cotizacion/agregar-asegurado-adicional',
      agregarAseguradoAdicionalRequest
    );
  }

  obtenerDatosInspeccion(
    cotizacionId: string
  ): Observable<DatosInspeccionResponse> {
    return this.http.get<DatosInspeccionResponse>(
      '/cotizacion/ObtenerDatosInspeccion',
      {
        params: {
          cotizacionId: cotizacionId,
        },
      }
    );
  }
}
